import React, {useContext, useEffect, useState} from "react";
import {useGetWallet} from "@hooks/wallet.ts";
import {ContextAppState} from "@app/context.ts";
import {Select} from "./select.tsx";
import Decimal from "decimal.js";
import {Send} from "@pages/account-send/send.tsx";

export type Token = {
    mint: string,
    name: string,
    symbol: string,
    image?: string,
}

export type TokenWithAmount = {
    token: Token;
    amount: Decimal;
}


export const AccountSendPage = ({}) => {
    const appState = useContext(ContextAppState);
    const [wallet, walletLoading, walletError, getWallet] = useGetWallet();
    const [selectedToken, setSelectedToken] = useState<TokenWithAmount | undefined>(undefined);

    // useEffect(() => {
    //     if (appState.type === 'Telegram') {
    //         // @ts-ignore
    //         const tg = window.Telegram.WebApp;
    //         tg.BackButton.show();
    //         const handleBackClick = () => {
    //             window.history.back();
    //         };
    //         tg.BackButton.onClick(handleBackClick);
    //
    //         return () => {
    //             tg.BackButton.hide();
    //             tg.BackButton.offClick(handleBackClick);
    //         };
    //     }
    // }, [appState.type]);

    useEffect(() => {
        const abortController = new AbortController();
        getWallet(appState.wallet.id, abortController)
        return () => abortController.abort();
    }, [getWallet]);

    if (walletLoading || !wallet) {
        return (<h1> Loading..</h1>)
    }

    // const balance = new Decimal(wallet.native?.amount || "0");

    return (
        <>
            {selectedToken ? (
                <Send tokenWithAmount={selectedToken}/>
            ) : (
                <Select
                    tokenWithAmount={wallet.token.map((t) => ({
                        ...t,
                        amount: new Decimal(t.amount),
                    }))}
                    onSelect={setSelectedToken}
                />
            )}
        </>
    );
};
